"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialSearchActions = void 0;
const ActionEnums_1 = require("../../../enums/ActionEnums");
exports.partialSearchActions = {
    createInitializeAction: () => ({
        type: ActionEnums_1.PartialSearchActionTypes.INIT,
    }),
};
